import * as React from "react";
import {connect as formikConnect} from "formik";
import {useIntl} from "react-intl";
import {connect as reduxConnect} from "react-redux";

import {UserWithCustomer} from "../../Models/UserWithCustomer";
import {AllPermissions, PolicyContext} from "../../../Policy/Provider";
import {PolicyNameEnum} from "../../../PolicyNameEnum";
import {InnerFrame, SwitchHeader} from "./styles";
import Switch from "../../../../Elements/Switch";
import DateSelector from "./DateSelector";
import {LabelEnum} from "../../LabelEnum";
import { AppState } from "@Safemate/Store/types";
import {Moment} from "moment";


interface ApiAdminProps{
  isNew: boolean;
  user: UserWithCustomer
}

const mapStateToProps = ({users: {action: {edit: {isNew, user}}}}: AppState) => {
  return {
    isNew,
    user,
  }
}

const ApiAdmin = reduxConnect(mapStateToProps)(
  formikConnect<ApiAdminProps, UserWithCustomer>(
    ({isNew, user, formik: {setFieldValue, values: {user: {apiAdmin, deactivatedTo, deactivatedFrom}}}}) => {

      const permissions = React.useContext(PolicyContext) as Map<PolicyNameEnum, AllPermissions>;
      const isAllowed = permissions.has(PolicyNameEnum.ACTIVATE) && permissions.get(PolicyNameEnum.ACTIVATE).generalPermissions.all;
      const {formatMessage} = useIntl();

      if (!isAllowed || user.role !== 1) return null;

      return (
        <InnerFrame border>
          <SwitchHeader>
            {formatMessage({id: LabelEnum.API_ADMIN_TEXT, defaultMessage: "API Admin"})}
          </SwitchHeader>
          <Switch
            checked={apiAdmin}
            onChange={(value: boolean) => {
              setFieldValue("user.apiAdmin", value);
            }}
          />
        </InnerFrame>
      )
    }
  )
)


export default ApiAdmin;
